import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { StaticService } from '../../../services/static.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss']
})
export class StaticPageComponent implements OnInit {

    code: string = "";

    pagecode: string = "static-";

    constructor(private route: ActivatedRoute,
        private router: Router, private staticService: StaticService,
        private authentication: AuthenticationService,
        private common: CommonService) {

        this.route.params.subscribe(val => {

            let map: any = this.route.paramMap;
            this.code = map.destination._value.code;


            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode + this.code).subscribe(
                (res: any) => {
                    if (res.success && res.data) {
                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode + this.code, this.pagecode + this.code);
                        this.getStaticPageByCode();
                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }

    accessdenied: boolean = false;



    ngOnInit(): void {

    }
    getStaticPageByCode() {

        this.staticService.getStaticPageByCode(this.code).subscribe(
            (res: any) => {
                if (res.success) {

                    (document.getElementById("pageIframe") as HTMLIFrameElement).src = res.data.pageURL;
                    (document.getElementById("pageIframe") as HTMLIFrameElement).height = res.data.pageHeight;
                    (document.getElementById("pageIframe") as HTMLIFrameElement).width = res.data.pageWidth;

                }
                else {
                    this.accessdenied = true;
                }

            },
            (err: any) => {
                console.error("getStaticPageByCode()", err);
                this.accessdenied = true;
            }

        );



    }

}
